export default __webpack_public_path__ + "static/media/not-sure.3be97221.svg";